import React from 'react';
import { useNavigate } from 'react-router-dom';

const POLink = ({ prId, label }) => {
  const navigate = useNavigate();
  if (!prId) return <span className="text-slate-500">{label || '-'}</span>;
  return (
    <button
      type="button"
      onClick={() => navigate(`/purchase/requests?open=${prId}`)}
      className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium"
      data-testid={`drilldown-po-link-${prId}`}
    >
      {label || 'View PO'}
    </button>
  );
};

export const DeliveryDrilldown = ({ rows = [] }) => {
  if (!rows.length) {
    return <p className="text-[11px] text-slate-400 py-2 px-1">No delivery records in this period.</p>;
  }
  return (
    <div className="overflow-x-auto" data-testid="delivery-drilldown">
      <table className="w-full text-[11px]">
        <thead className="text-slate-500 border-b">
          <tr>
            <th className="text-left font-medium py-1.5 px-2">PO / PR No.</th>
            <th className="text-left font-medium py-1.5 px-2">Due Date</th>
            <th className="text-left font-medium py-1.5 px-2">Receipt Date</th>
            <th className="text-right font-medium py-1.5 px-2">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.pr_id} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="py-1.5 px-2"><POLink prId={r.pr_id} label={r.po_number || r.pr_number} /></td>
              <td className="py-1.5 px-2 font-mono">{r.expected_delivery_date}</td>
              <td className="py-1.5 px-2 font-mono">{r.received_date}</td>
              <td className="py-1.5 px-2 text-right">
                <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-medium ${r.on_time ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                  {r.on_time ? 'On Time' : 'Delayed'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const QualityDrilldown = ({ rows = [] }) => {
  if (!rows.length) {
    return <p className="text-[11px] text-slate-400 py-2 px-1">No QC-inspected receipts in this period.</p>;
  }
  return (
    <div className="overflow-x-auto" data-testid="quality-drilldown">
      <table className="w-full text-[11px]">
        <thead className="text-slate-500 border-b">
          <tr>
            <th className="text-left font-medium py-1.5 px-2">Item</th>
            <th className="text-left font-medium py-1.5 px-2">Invoice</th>
            <th className="text-left font-medium py-1.5 px-2">PO / PR No.</th>
            <th className="text-left font-medium py-1.5 px-2">Date</th>
            <th className="text-right font-medium py-1.5 px-2 text-emerald-600">Accepted</th>
            <th className="text-right font-medium py-1.5 px-2 text-amber-600">Quarantined</th>
            <th className="text-right font-medium py-1.5 px-2 text-red-600">Rejected</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.txn_id} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="py-1.5 px-2">{r.item_unique_id ? `${r.item_unique_id} — ` : ''}{r.item_name}</td>
              <td className="py-1.5 px-2 font-mono">{r.invoice_number || r.reference_number || '-'}</td>
              <td className="py-1.5 px-2"><POLink prId={r.pr_id} label={r.po_number} /></td>
              <td className="py-1.5 px-2 font-mono">{r.date}</td>
              <td className="py-1.5 px-2 text-right font-medium text-emerald-700">{r.accepted_qty}</td>
              <td className="py-1.5 px-2 text-right text-amber-700">{r.quarantined_qty}</td>
              <td className="py-1.5 px-2 text-right text-red-700">{r.rejected_qty}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
